import { gql } from "@apollo/client";
import { MetadataFragmentDoc } from "@dashboard/graphql";

export const SHOP_METADATA = gql`
  query ShopMetadata {
    shop {
      id
      ...Metadata
    }
  }
  ${MetadataFragmentDoc}
`;

export const HTML_WIDGETS = gql`
  query HtmlWidgets {
    shop {
      id
      ...Metadata
    }
  }
  ${MetadataFragmentDoc}
`;

